import React, { PureComponent } from 'react'
import { ThemeProvider } from 'styled-components'

import Icon from 'modules/common/components/icon/Icon'
import { ICONS } from 'modules/common/components/icon/Icons'
import Button from 'modules/common/components/button/Button'
import SuggestionList from 'modules/search/components/SuggestionList'
import ui from 'modules/search/ui'
import themes from 'modules/common/components/ui/themes'

import { APP_THEME } from 'config'

class SearchFormMin extends PureComponent {

  handleFocus = () => {
    if(this.suggestionList){
      this.suggestionList.resetSelectedIndex()
    }
  }

  render(){
    const {
      submitEnabled,
      placeholder,
      label,
      value,
      suggestions = [],
      onTextChange,
      onSuggestionClick,
      onSubmit,
      onSubmitClick,
      buttonText = ''
    } = this.props;
    return (
      <ui.SearchWrapMin fixed={false}>
        <ThemeProvider theme={themes[APP_THEME]}>
          <ui.SearchForm.Form
            onSubmit={onSubmit}
            autoComplete="off"
            autoCorrect="off"
            noValidate
            spellCheck="false"
          >
            { label && <label className="text--left" htmlFor="search-text">{ label }</label>}
            <ui.SearchForm.FieldsetMin>
              <Icon icon={ICONS.SEARCH} />
              <input
                placeholder={placeholder}
                value={value}
                onChange={onTextChange}
                className="searchform__input"
                name="location"
                onFocus={this.handleFocus}
              />
              <Button
                disabled={!submitEnabled}
                onClick={onSubmitClick}
                onFocus={this.handleFocus}
                secondary
              >
                {buttonText}
              </Button>
            </ui.SearchForm.FieldsetMin>
            { suggestions.length !== 0 && <SuggestionList ref={el => this.suggestionList = el} items={suggestions} onChange={onSuggestionClick} />}
          </ui.SearchForm.Form>
        </ThemeProvider>
      </ui.SearchWrapMin>
    );

  }

}

export default SearchFormMin



// WEBPACK FOOTER //
// ./src/modules/search/components/SearchFormMin.js